// extracted by mini-css-extract-plugin
module.exports = {"Teasers__item":"L27j","Teasers__header":"Dh2D","Teasers__item__index-0":"_0YTZ","Teasers__item__index-1":"_1IWu"};